import { parseDateFromMW } from '~app/shared/functions/utils/utils.function';
interface IPolicy {
  policyIdentifier: string;
  name: string;
  contentVersion: string;
}

export class AssignmentPolicies {
  public data: {
    crewMemberId: string;
    timestamp: string;
    shipCode: string;
    signonDate: string;
    policies: Array<IPolicy>;
  };

  constructor(data: any) {
    this.data = data;
  }

  public get policies(): Array<IPolicy> {
    if (!this.data.policies) return [];
    return this.data.policies;
  }

  public get signDate(): Date | undefined {
    const timestamp = this.data?.timestamp?.substring(0, 8);

    if (!timestamp) {
      return undefined;
    }

    try {
      const parsedDate = parseDateFromMW(timestamp);
      return new Date(parsedDate);
    } catch (error) {
      console.error('Error parsing date:', error);
      return undefined;
    }
  }
}
